/**
 * Configuración centralizada para el servicio de email
 */

// Configuración de email
export const EMAIL_CONFIG = {
  // Configuración de reintentos
  MAX_RETRIES: 3,
  RETRY_DELAY: 1000, // 1 segundo base
  RETRY_BACKOFF_MULTIPLIER: 2, // Multiplicador para backoff exponencial
  
  // Configuración de timeouts
  TIMEOUT: 30000, // 30 segundos
  
  // Límites de contenido
  MAX_SUBJECT_LENGTH: 200,
  MAX_CONTENT_LENGTH: 50000,
  
  // Configuración de desarrollo
  DEV_SIMULATION_DELAY: 100, // ms
  
  // URLs de funciones serverless
  NETLIFY_FUNCTION_URL: '/.netlify/functions/send-email',
  LOCAL_NETLIFY_URL: 'http://localhost:8888/.netlify/functions/send-email'
};

// Plantillas de email
export const EMAIL_TEMPLATES = {
  ACTA_CREATION: {
    SUBJECT_PREFIX: '[IETS GESTOR ACTAS] Nueva acta creada y asignada:',
    COLORS: {
      PRIMARY: '#1976d2',
      BACKGROUND: '#f5f5f5',
      BORDER: '#eee'
    }
  },
  
  ACTA_APPROVAL: {
    SUBJECT_PREFIX: '[IETS GESTOR ACTAS] Acta aprobada:',
    COLORS: {
      SUCCESS: '#4caf50',
      SUCCESS_BG: '#e8f5e8',
      SUCCESS_BORDER: '#4caf50',
      INFO: '#1976d2',
      INFO_BG: '#f0f8ff'
    }
  },
  
  COMMON: {
    FOOTER: {
      ORGANIZATION: 'Instituto de Evaluación Tecnológica en Salud - IETS',
      DISCLAIMER: 'Este es un correo automático, por favor no responda a este mensaje.'
    },
    STYLES: {
      CONTAINER: 'font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;',
      FOOTER: 'margin-top: 30px; padding-top: 20px; border-top: 1px solid #eee; font-size: 12px; color: #666;'
    }
  }
};

// Configuración de logging
export const LOGGING_CONFIG = {
  ENABLE_STRUCTURED_LOGGING: true,
  LOG_EMAIL_CONTENT_PREVIEW: true,
  EMAIL_PREVIEW_LENGTH: 200,
  MASK_EMAIL_ADDRESSES: true,
  EMAIL_MASK_LENGTH: 3
};

// Configuración de validación
export const VALIDATION_CONFIG = {
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  REQUIRED_ACTA_FIELDS: ['numeroActa'],
  OPTIONAL_ACTA_FIELDS: ['tipoProyecto', 'fecha', 'responsable', 'creatorEmail']
};

// Configuración de métricas
export const METRICS_CONFIG = {
  ENABLE_METRICS: true,
  TRACK_EMAIL_DURATION: true,
  TRACK_RETRY_ATTEMPTS: true,
  TRACK_SUCCESS_RATE: true
};

// Función para obtener configuración según el entorno
export const getEnvironmentConfig = () => {
  const isDev = import.meta.env.DEV;
  const isProd = import.meta.env.PROD;
  
  return {
    environment: isDev ? 'development' : isProd ? 'production' : 'unknown',
    isDevelopment: isDev,
    isProduction: isProd,
    emailSimulation: isDev,
    enableDetailedLogging: isDev,
    functionUrl: isDev ? EMAIL_CONFIG.LOCAL_NETLIFY_URL : EMAIL_CONFIG.NETLIFY_FUNCTION_URL
  };
};

// Exportar configuración por defecto
export default {
  EMAIL_CONFIG,
  EMAIL_TEMPLATES,
  LOGGING_CONFIG,
  VALIDATION_CONFIG,
  METRICS_CONFIG,
  getEnvironmentConfig
};